import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { AppShell } from './components/AppShell';
import { AuthProvider } from './hooks/useAuth';
import { AuthGate } from './components/AuthGate';
import { HomePage } from './pages/HomePage';
import { LoginPage } from './pages/LoginPage';
import { NoteDetailPage } from './pages/NoteDetailPage';
import { SettingsPage } from './pages/SettingsPage';

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <AppShell>
          <Routes>
            <Route path="/login" element={<LoginPage />} />
            <Route
              path="/*"
              element={
                <AuthGate>
                  <Routes>
                    <Route path="/" element={<HomePage />} />
                    <Route path="/notes/:id" element={<NoteDetailPage />} />
                    <Route path="/settings" element={<SettingsPage />} />
                  </Routes>
                </AuthGate>
              }
            />
          </Routes>
        </AppShell>
      </AuthProvider>
    </BrowserRouter>
  );
}
